import { createSelector, createFeatureSelector } from '@ngrx/store';
import { Ingredient, IngredientsState } from 'src/app/shared/model';

import { adapter } from './ingredients.reducer';

const {
  // selectIds,
  selectEntities,
  selectAll,
  // selectTotal
} = adapter.getSelectors();

export const getIngredientsState = createFeatureSelector<IngredientsState>('ingredients');

export const getIngredientsEntities = createSelector(getIngredientsState, selectEntities);

export const getIngredients = createSelector(getIngredientsState, selectAll);

export const getIngredient = createSelector(
  getIngredientsEntities,
  (ingredients: { [key: string]: Ingredient }, props: { id: string }) => ingredients[props.id],
);
